import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useImmer } from 'use-immer'

import { useMediaQueryUtils } from 'constants/exportHooks'
import {
    getMoreTechnologies,
    getTechnologies,
    getTechnologyStats,
    resetTechnologyBrowserState,
} from 'store/technologies/actions'
import ImagePlaceholder from 'assets/image-placeholder.svg'
import SearchIcon from 'assets/search_icon_old.svg'
import Image from 'components/common/ImageLoader'
import Spinner from 'components/common/Spinner'
import TechnologyBrowserStats from './stats'
import TechnologyFilter from './filter'
import './index.scss'
import useLoadMoreOnScroll from 'hooks/useLoadMoreOnScroll'

const queryString = require('query-string')

const TechnologyBrowser = (props) => {
    const { isDesktop, isMobile, isTablet } = useMediaQueryUtils()
    const dispatch = useDispatch()
    const [state, setState] = useImmer({
        searchText: '',
        isLoading: true,
        filterQueryParams: {},
    })

    const { searchText, isLoading, filterQueryParams } = state

    const technologyBrowserState = useSelector(
        (state) => state.technologyBrowserState?.list
    )

    const technologyBrowserResult = useSelector(
        (state) => state.technologyBrowserState?.list?.data
    )

    const technologyStats = useSelector(
        (state) => state.technologyBrowserState?.stats?.data
    )

    useLoadMoreOnScroll(
        technologyBrowserState?.count,
        technologyBrowserResult,
        technologyBrowserState?.nextPage,
        (string) => dispatch(getMoreTechnologies(string))
    )

    // initial mount
    useEffect(() => {
        // fetch technology stats data
        dispatch(getTechnologyStats())

        return () => {
            dispatch(resetTechnologyBrowserState())
        }
    }, [])

    // Update 'loading' state to false if state changes
    useEffect(() => {
        setState((draft) => {
            draft.isLoading = false
        })
    }, [technologyBrowserResult])

    const updateFilterQueryParams = (field, value) => {
        if (field && value) {
            // this indicates filter params are available and should be updateed
            setState((draft) => {
                draft.isLoading = true
                draft.filterQueryParams = {
                    field,
                    value,
                }
            })
        } else {
            let str = ''
            // this indicates reset filter hence execute query with existing params
            setState((draft) => {
                draft.isLoading = true
                draft.filterQueryParams = {}
            })

            dispatch(getTechnologies(str))
        }
    }

    const widthForRows = props?.hideStats ? 'sm:w-6/6' : 'sm:w-4/6'

    return (
        <React.Fragment>
            <div className="bg-white ">
                <div className="w-full flex flex-wrap">
                    <div className={`w-full `}>
                        <div
                            className=" 
                        "
                        >
                            <div className=" ">
                                <div className=" text-page-title font-bold">
                                    {technologyBrowserState?.count || 0}
                                    <span className=" text-primary-purple-500 px-2">
                                        Technologies
                                    </span>
                                    found
                                </div>
                                {technologyBrowserResult &&
                                    (technologyBrowserResult.length > 0 ? (
                                        technologyBrowserResult.map(
                                            (item, index) => (
                                                <React.Fragment key={index}>
                                                    <div
                                                        id={`result-box-fingerprint-${index}`}
                                                        className="flex items-center w-full  
                                                        px-6 py-6 my-4 
                                                        transition duration-150 ease-in-out 
                                                        border-2 border-gray-200 hover:border-info-active rounded-md"
                                                    >
                                                        <div className="w-2/3 md:w-2/3 xl:w-2/3 ">
                                                            <div className="flex flex-wrap items-center py-4 px-4 rounded-md">
                                                                {' '}
                                                                {item.public_thumb_path ? (
                                                                    <Image
                                                                        src={`https://api.intrigue.io/${item.public_thumb_path}`}
                                                                        width={
                                                                            isTablet ||
                                                                            isMobile
                                                                                ? '25'
                                                                                : '45'
                                                                        }
                                                                        height={
                                                                            isTablet ||
                                                                            isMobile
                                                                                ? '25'
                                                                                : '45'
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <Image
                                                                        width={
                                                                            isTablet ||
                                                                            isMobile
                                                                                ? '25'
                                                                                : '45'
                                                                        }
                                                                        height={
                                                                            isTablet ||
                                                                            isMobile
                                                                                ? '25'
                                                                                : '45'
                                                                        }
                                                                        src={
                                                                            ImagePlaceholder
                                                                        }
                                                                    />
                                                                )}
                                                                <div className="ml-4 sm:text-sm md:text-md lg:text-lg">
                                                                    <div className="font-bold lg:w-20 xl:w-32 4xl:w-auto">
                                                                        {
                                                                            item.product
                                                                        }
                                                                    </div>
                                                                    <div className="mt-2 text-sm font-light">
                                                                        {
                                                                            item.vendor
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* {isDesktop ? (
                        <div className="w-1/3 md:w-2/3 xl:w-1/3 flex flex-wrap items-center justify-center px-4">
                          <div className="block text-center p-2  text-neutrals-n700  ">
                            <div className="text-xl font-bold">
                              {item?.count_unique || '-'}
                            </div>
                            <div className="mt-4">Instances</div>
                          </div>
                          <div className="block ml-4 py-2 px-4 text-center  text-greens-g500 border-r border-l border-gray-400 ">
                            <div className="text-xl font-bold">
                              {item?.count_unique_organizations || '-'}
                            </div>
                            <div className="mt-4">Organizations</div>
                          </div>
                          <div className="block ml-4 p-2 text-center text-reds-r500 ">
                            <div className="text-xl font-bold">
                              {item?.count_unique_f500s || '-'}
                            </div>
                            <div className="mt-4">F500s</div>
                          </div>
                        </div>
                      ) : null} */}
                                                        <div className="w-1/3 md:w-1/3 xl:w-1/3 text-right flex items-center justify-center flex-col">
                                                            <div className="px-8">
                                                                Categories
                                                            </div>
                                                            <div className="flex flex-wrap items-center justify-center mt-4">
                                                                {item
                                                                    ?.categories
                                                                    ?.length > 0
                                                                    ? item?.categories.map(
                                                                          (
                                                                              item,
                                                                              index
                                                                          ) => (
                                                                              <React.Fragment
                                                                                  key={
                                                                                      index
                                                                                  }
                                                                              >
                                                                                  <div className="mx-1 my-1 xl:my-0 px-2 py-1 bg-gray-200">
                                                                                      {
                                                                                          item
                                                                                      }
                                                                                  </div>
                                                                              </React.Fragment>
                                                                          )
                                                                      )
                                                                    : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        )
                                    ) : (
                                        <div className="p-10 flex items-center justify-center w-full  border border-gray-300 font-bold">
                                            No results found
                                        </div>
                                    ))}
                                {technologyBrowserState.loading && (
                                    <div className="p-10 flex items-center justify-center w-full">
                                        <Spinner
                                            loaderSize="lg"
                                            color="#6157E5"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default TechnologyBrowser
